import type { AgeOpenResponse } from "@/api/useStatistics.types"

export const ageOpenIssuesSelector = (response: AgeOpenResponse) => {
  const { data, ...restResponse } = response || {}

  const { bySeverity = [], ...rest } = data || {}
  let maxBySeverity = 0

  return {
    data: {
      bySeverity: bySeverity.reduce(
        (acc, { buckets, severity }) => {
          ;(buckets || []).forEach((values) => {
            const { count, daysRangeStart, daysRangeEnd } = values

            if (maxBySeverity < values.count) maxBySeverity = count

            acc.push({
              severity: severity.toLowerCase(),
              periodRange: `${daysRangeStart} - ${daysRangeEnd}`,
              period:
                daysRangeEnd > 100 // if period is more then 100, display + instead of the interval
                  ? `${daysRangeStart}+`
                  : `${daysRangeStart} - ${daysRangeEnd}`,
              value: count
            })
          })

          return acc
        },
        [] as {
          period: string
          periodRange: string
          severity: string
          value: number
        }[]
      ),
      maxBySeverity,
      ...rest
    },
    ...restResponse
  }
}
